import httpUtil from "@/utils/httpUtil";

export const getProductsInfo = (params,type) => httpUtil.post("/api/crmPc/products/getProductsInfo", params,type);

export const selectProductsTypeList = params => httpUtil.post("/api/crmPc/products/selectProductsTypeList", params);
export const insertProducts = (params,type) => httpUtil.post("/api/crmPc/products/insertProducts", params,type);